<template>
  <div class="content">
    <nav-title />
    <div class="filter">
      <!-- <el-button type="primary" size="mini" @click="createTemplate">添加模板</el-button> -->

      <!-- <el-input type="number" size="mini" v-model="groupId" placeholder="模板组ID"/> -->

      <!-- <el-input size="mini" v-model="groupName" placeholder="模板组名称"/> -->

      <el-input type="number" size="small" v-model="id" placeholder="模板ID" />

      <el-input size="small" v-model="name" placeholder="模板名称" />

      <el-input type="number" size="small" v-model="size" placeholder="尺寸" />

      <el-button size="small" @click="resetCondition">重置</el-button>
      <el-button size="small" @click="handleCommand('Delete')"
        >批量删除</el-button
      >
    </div>
    <div class="list">
      <el-table
        ref="table"
        :data="list"
        stripe
        @selection-change="handleSelectionChange"
        width="100%"
        v-loading="loading"
      >
        <el-table-column type="selection" width="46"> </el-table-column>
        <el-table-column prop="id" label="模板ID" width="69"> </el-table-column>
        <el-table-column prop="name" label="模板名称"> </el-table-column>
        <el-table-column prop="templatePath" label="模板预览">
          <template slot-scope="scope">
            <div
              v-for="(data, index) in JSON.parse(scope.row.templatePath)"
              :key="index"
            >
              <img
                :src="data"
                style="max-height:50px;"
                alt=""
                @click="showImage(data)"
              />
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
                        prop="groupId"
                        label="模板组ID">
                </el-table-column> -->
        <!-- <el-table-column
                        prop="groupName"
                        label="模板组名称">
                </el-table-column> -->
        <el-table-column prop="id" label="坑位数量">
          <template slot-scope="scope">
            <div>{{ getImageCount(scope.row.content) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="尺寸">
          <template slot-scope="scope">
            <div>
              {{ scope.row.width || '0' }} x {{ scope.row.height || '0' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="容错图片">
          <template slot-scope="scope">
            <div v-for="(data, index) in scope.row.content" :key="index">
              <img
                :src="data.defaultPath"
                style="max-height:50px;"
                alt=""
                @click="showImage(data.defaultPath)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="适用系统">
          <template slot-scope="scope">
            <span>{{ getSource(scope.row.source) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="resizeType" label="适配类型">
          <template slot-scope="scope">
            <span>{{
              scope.row.resizeType === 1 ? '坑位尺寸' : '模板尺寸'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="94" prop="update_time" label="更新时间">
          <template slot-scope="scope">
            <p>
              {{ setMoment(scope.row.updatetime) }}
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column
                        prop="status"
                        label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.isOpen === 1? '启用':'禁用'}}</span>
                    </template>
                </el-table-column> -->
        <el-table-column prop="id" label="操作" width="110">
          <template slot-scope="scope">
            <span class="action" @click="handleEdit(scope.row.id)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-edit"></use>
              </svg>
            </span>
            <span class="action" @click="handlePreview(scope.row)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-preview"></use>
              </svg>
            </span>
            <span class="action" @click="handleDelete(scope.row.id)">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icon-delete"></use>
              </svg>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="预览" :visible.sync="preview">
      <div
        class="tpl"
        v-for="(tpl, i) in preview_template"
        v-show="preview_template.length"
        :key="i"
      >
        <div class="group">
          <div>
            <img
              :src="preview_results[i]"
              style="max-height:500px;max-width:100%"
            />
          </div>
          <div class="image" v-for="(img, index) in tpl.list" :key="index">
            <!-- <image-upload v-if="img.type===2"  @input="setMaterial(i, index, $event)"/> -->
            <images-upload
              v-if="img.type === 2"
              :fileList="[
                {
                  url: img.image.url
                }
              ]"
              :index="index"
              :extra="{ index, i }"
              :limit="tpl.list.length"
              :multiple="tpl.list.length > 1"
              @change="handleUpload"
            />
            <input
              v-else
              @input="setMaterialText(i, index, $event.target.value)"
              :value="img.text.text"
            />
          </div>
          <p v-if="tpl.list.length > 1">tips: 支持批量上传</p>
        </div>
        <el-button type="primary" size="mini" @click="previewResult(i)"
          >预览</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="预览" :visible.sync="imageShow" center="">
      <div class="image-tpl">
        <img :src="imageUrl" style="max-height:500px;max-width:100%;" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from 'utils/axios';
import ImageUpload from 'components/image-upload';
import ImagesUpload from 'components/upload/UploadWrapper';
import protobuf from 'protobufjs';
import moment from 'moment';
import ListMixins from 'mixins/list';
import NavTitle from 'components/NavTitle';

var root = protobuf.parse(proto, { keepCase: true }).root;

function base64(raw) {
  return btoa(String.fromCharCode.apply(null, raw))
    .replace(/\=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}
import config from 'utils/config';

import proto from './proto';

export default {
  name: 'TemplateList',
  mixins: [ListMixins],
  components: {
    'image-upload': ImageUpload,
    'nav-title': NavTitle,
    ImagesUpload
  },
  data() {
    return {
      namespace: 'group',
      preview: false,
      groupId: '',
      id: null,
      size: '',
      groupName: '',
      name: '',
      selection: [],
      preview_results: [],
      images: [],
      preview_template: [],
      imageUrl: '',
      imageShow: false
    };
  },
  watch: {
    groupId() {
      this.queryList();
    },
    id() {
      this.queryList();
    },
    size() {
      this.queryList();
    },
    groupName() {
      this.queryList();
    },
    name() {
      this.queryList();
    }
  },
  mounted() {
    if (this.$route.query.gid) {
      this.groupId = this.$route.query.gid;
    }
    this.queryList();
    this.fetchGroup();
  },
  computed: {
    group() {
      return this.$store.state.group.list || [];
    },
    list() {
      return this.$store.state.template.list.filter(item => item.status === 0);
    },
    total() {
      return this.$store.state.template.total;
    },
    limit() {
      return this.$store.state.template.pageSize;
    }
  },
  beforeDestroy() {
    this.$store.commit('template/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    setMoment(data) {
      return moment(data).format('YYYY-MM-DD hh:mm:ss');
    },
    previewResult(i) {
      const {
        resize_width,
        resize_height,
        template_style,
        list,
        idx
      } = this.preview_template[i];
      let data = {
        idx: +idx,
        resize_width,
        resize_height,
        template_style,
        native: { item: list },
        template_version: + Math.random().toString().slice(-6)
      };
      const Message = root.lookup('pic_resize_data.DynamicTemplate');
      const msg = Message.create(data);
      const buf = Message.encode(msg).finish();
      const encode_string = base64(buf);

      this.preview_results[i] =
        config.HOST + '/api/infoStream?src=' + encode_string;
      this.preview_results = Object.assign([], this.preview_results);
    },
    setMaterial(i, index, url) {
      this.preview_template[i].list[index].image.url = url;
      console.log(this.preview_template);
    },
    setMaterialText(i, index, url) {
      this.preview_template[i].list[index].text.text = url;
    },
    getImageCount(content) {
      if (content === null) {
        return 0;
      }
      let list = [];
      Object.keys(content)
        .map(key => content[key].list)
        .forEach(l => {
          list = list.concat(l);
        });
      return list.filter(item => item.isDynamic === 1).length;
    },
    getSource(source) {
      switch (source) {
        case 1:
          return 'FTX';
        case 2:
          return '海神';
        case 0:
          return '通用';
        default:
          return '其他';
      }
    },
    queryList() {
      this.$store.commit('template/update', {
        condition: {
          name: this.name || undefined,
          groupName: this.groupName || undefined,
          id: this.id || undefined,
          groupId: this.groupId || undefined,
          size: this.size || undefined
        }
      });
      this.refreshData();
    },
    resetCondition() {
      this.$store.commit('template/update', {
        condition: {}
      });
      this.groupId = '';
      this.id = null;
      this.size = '';
      this.groupName = '';
      this.name = '';
      this.refreshData();
    },
    createTemplate() {
      this.$router.push('/works/create');
    },
    refreshData() {
      this.handleChangePage(1);
    },
    fetchData() {
      this.loading = true;
      this.$store
        .dispatch('template/fetch', {
          design_type: 0
        })
        .then(() => {
          this.loading = false;
        });
    },
    fetchGroup() {
      this.$store.dispatch('group/fetch', {});
    },
    handleEdit(id) {
      this.$router.push('/works/site/' + id);
    },
    handleCommand(command) {
      // if (command === 'Activate') {
      // 	this.batchActivate(this.selection, 1)
      // } else if (command === 'Deactivate') {
      // 	this.batchActivate(this.selection, 0)
      // } else {
      this['batch' + command](this.selection);
      // }
    },
    handlePreview({ id, content }) {
      this.preview_results = [];
      this.preview_template = [];
      this.$nextTick(() => {
        this.preview_template = Object.keys(content).map((k, i) => {
          return {
            list: content[k].list
              .filter(item => item.isDynamic === 1)
              .map(data => {
                if (data.type === 'image') {
                  return {
                    type: 2,
                    image: { url: '' },
                    width: data.width,
                    height: data.height
                  };
                } else if (
                  data.type === 'text' ||
                  data.type === 'title' ||
                  data.type === 'digest' ||
                  data.type === 'advertuser'
                ) {
                  let map = {
                    text: 6,
                    title: 1,
                    digest: 5,
                    advertuser: 9
                  };
                  return {
                    type: map[data.type],
                    text: { text: data.content },
                    width: data.width,
                    height: data.height
                  };
                }
              }),
            idx: k,
            template_style: id,
            resize_width: content[k].width,
            resize_height: content[k].height
          };
        });
        this.preview = true;
      });
    },
    batchActivate(ids, isOpen) {
      this.$refs.table.clearSelection();
      this.$store
        .dispatch('template/activate', {
          ids,
          isOpen
        })
        .then(() => {
          this.selection = [];
          this.refreshData();
        });
    },
    batchDelete(ids) {
      this.$confirm('是否删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$refs.table.clearSelection();
        this.$store
          .dispatch('template/delete', {
            ids
          })
          .then(() => {
            this.selection = [];
            this.$message.success('删除成功');
            this.refreshData();
          });
      });
    },
    handleSizeChange(pageSize) {
      this.$store.commit('template/update', {
        page: 1,
        pageSize
      });
      this.fetchData();
    },
    handleChangePage(page) {
      this.$store.commit('template/update', {
        page
      });
      this.fetchData();
    },
    handleActivate(id, isOpen) {
      this.batchActivate([id], isOpen);
    },
    handleDelete(id) {
      this.batchDelete([id]);
    },
    handleSelectionChange(selection) {
      this.selection = selection.map(item => item.id);
    },

    showImage(url) {
      this.imageUrl = url;
      this.imageShow = true;
    },
    handleUpload(urls, extra) {
      let imageIndex = 0;

      _.each(this.preview_template[extra.i].list, (item, index) => {
        if (item.type === 2) {
          if (index >= extra.index && urls.length > imageIndex) {
            item.image.url = urls[imageIndex++];
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  color: #3fb7ff;
  font-size: 16px;
  margin-right: 14px;
  :last-child {
    margin: 0;
  }
}
.content {
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04);
  overflow: hidden;
  .filter {
    background: #fff;
    padding: 20px 24px;
    display: flex;
    border-radius: 4px 4px 0 0;
    align-items: center;
    > * {
      margin: 0 8px 0 0;
      max-width: 150px;
    }
  }
  .list {
    background: white;
    padding: 0 24px;
    border-radius: 0 0 4px 4px;
  }
}

.tpl {
  .image {
    margin-right: 10px;
    display: inline-block;
    > * {
      vertical-align: middle;
    }
  }
}
.image-tpl {
  text-align: center;
}
</style>
